import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { siteConfig } from "@/config/site.config";

interface LogoProps {
  className?: string;
  /** Force a color scheme regardless of surface. */
  tone?: "default" | "invert";
}

/** VibeWell wordmark + geometric mark. Links home. */
export function Logo({ className, tone = "default" }: LogoProps) {
  return (
    <Link
      to="/"
      aria-label={`${siteConfig.name} home`}
      data-testid="site-logo"
      className={cn(
        "group inline-flex items-center gap-2.5 font-heading text-lg font-extrabold tracking-tight",
        tone === "invert" ? "text-white" : "text-foreground",
        className,
      )}
    >
      {/* <span className="relative inline-flex h-8 w-8 items-center justify-center overflow-hidden rounded-[10px] bg-primary text-primary-foreground shadow-[0_6px_16px_-4px_rgba(15,118,110,0.55)]">
        <span className="absolute inset-0 bg-gradient-to-br from-accent/70 to-transparent opacity-80" />
        <svg
          viewBox="0 0 24 24"
          className="relative h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth={2.4}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 13c3 0 3-6 6-6s3 12 6 12 3-6 6-6" />
        </svg>
      </span> */}
      <div className="h-8 w-8 rounded-[10px]">
        <img src="/images/vibewellLogo.png" alt="Logo" className="object-contain rounded-[10px]" />
      </div>
      <span
        className="
        bg-gradient-to-r
        from-cyan-500
        via-blue-500
        to-purple-500
        bg-clip-text
        text-transparent
        font-black
        "
      >
        VibeWell
    </span>
      {/* <span>
        Vibe<span className="text-primary">Well</span>
      </span> */}
    </Link>
  );
}
